import axios from '@/http.js';
export const NEWS_MGT_TABLE = 'api/ad/list';
export default {
    getNews(){
        return axios.get('api/ad/list');
    },
    addNews (data) {
        return axios.post('api/ad/put', data);
    },
    updateNews (data) {
        return axios.put('api/ad/update', data);
    },
    launchNews (id) {
        return axios.put(`api/ad/launch/${id}`);
    },
    withdrawNews (id) {
        return axios.put(`api/ad/withdraw/${id}`);
    },
    readNews (ids) {
        return axios.put(`api/ad/read`, ids);
    },
    delNews (id) {
        return axios.delete(`api/ad/${id}`);
    },
}